export interface ApplicationSetting {
  id: string;
  key: string;
  description: string;
  value: string;
}
